import { i18n } from "./index";

export function resolveLocalizedTitle(title: unknown, fallback = ""): string {
  if (typeof title === "string") return title || fallback;
  if (!title || typeof title !== "object") return fallback;

  const locale = i18n.global.locale.value;
  for (const key of [locale, "zh-CN", "zh-TW", "en-US"]) {
    if (key in title) {
      const value: unknown = Reflect.get(title, key);
      if (typeof value === "string" && value) return value;
    }
  }
  return fallback;
}
